// extracted by mini-css-extract-plugin
module.exports = {"root":"MainLayout_root__n7FVx","main":"MainLayout_main__eh4dB"};